export enum PaymentFlowType {
  deposit = 'deposit',
  transfer = 'transfer',
  withdraw = 'withdraw',
  internalTransfer = 'internal-transfer',
}
